import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { StatusBadge } from "../../../../../common/Badge";

const TransactionAccessTable = ({
  data,
  onEdit,
  currentPage,
  setCurrentPage
}) => {
  const headers = [
    "ID",
    "Access Type",
    "Is Full Transaction Access",
    "Actions"
  ];

  const accessors = [
    "id",
    "description",
    "isFullTransactionAccess",
    "actions"
  ];

  const customCellRenderer = (row, accessor) => {
    if (accessor === "isFullTransactionAccess") {
      return <StatusBadge status={row[accessor] ? "Yes" : "No"} />;
    }
    return null;
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Transaction Access List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default TransactionAccessTable;